module.exports = __webpack_public_path__ + "a768e7de/img/pdf-icon.79f04a36.svg";